import { render, staticRenderFns } from "./UserRowSimple.vue?vue&type=template&id=0efd5bce&"
import script from "./UserRowSimple.vue?vue&type=script&lang=js&"
export * from "./UserRowSimple.vue?vue&type=script&lang=js&"
import style0 from "./UserRowSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports